import React, { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Box.module.scss';

export interface IBox extends HTMLAttributes<HTMLDivElement> {
  noOffset?: boolean;
  halfPadding?: boolean;
  className?: string;
}

const Box: FC<IBox> = ({ children, noOffset, className, halfPadding }) => {
  const classes = classNames(styles['ta-box'], className, {
    [styles['no-offset']]: noOffset,
    [styles['half-padding']]: halfPadding,
  });

  return <div className={classes}>{children}</div>;
};

export default Box;
